import { DocumentReaderRunState } from './types';

/** A run in one of these states never changes again. */
export const DOCUMENT_READER_FINISHED_RUN_STATES: readonly DocumentReaderRunState[] =
  [
    DocumentReaderRunState.COMPLETED,
    DocumentReaderRunState.STOPPED,
    DocumentReaderRunState.FAILED,
  ];

/** A sent room's pills read at most this many batches of file names; a larger room shows one pill. */
export const DOCUMENT_READER_SENT_BATCH_READ_LIMIT = 10;
